<div [@routerTransition]>
    <sub-header [title]="'Locations' | localize" [description]="'LocationsHeaderInfo' | localize">
        <div role="actions">
            <button
                id="btn_create_location"
                *ngIf="'Pages.Locations.Create' | permission"
                (click)="createLocation()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewLocation') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input
                                            [(ngModel)]="filterText"
                                            (ngModelChange)="getLocations()"
                                            name="filterText"
                                            autoFocus
                                            type="text"
                                            class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')"
                                        />
                                        <button class="btn btn-primary" type="submit" (click)="getLocations()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="CompanyNameFilter">
                                        ({{ l('Company') }}) {{ l('Name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="CompanyNameFilter"
                                        name="companyNameFilter"
                                        [(ngModel)]="companyNameFilter"
                                    />
                                </div>
                            </div>
                            <div class="col-md-12 mt-5">
                                <button
                                    (click)="resetFilters()"
                                    class="btn btn-secondary btn-sm"
                                    id="btn-reset-filters"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getLocations($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Locations.Edit', 'Pages.Locations.Delete')"
                                    >
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="companyFk.name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="companyName"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="code">
                                        {{ l('Code') }}
                                        <p-sortIcon field="location.code"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="location.name"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="address1">
                                        {{ l('Address1') }}
                                        <p-sortIcon field="location.address1"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="phone">
                                        {{ l('Phone') }}
                                        <p-sortIcon field="location.phone"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="email">
                                        {{ l('Email') }}
                                        <p-sortIcon field="location.email"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Locations.Edit', 'Pages.Locations.Delete')"
                                    >
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a
                                                        *ngIf="permission.isGranted('Pages.Locations.Edit')"
                                                        class="dropdown-item"
                                                        [routerLink]="['/app/master/locations/createOrEdit']"
                                                        [queryParams]="{ id: record.location.id }"
                                                    >
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        class="dropdown-item"
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.Locations.Delete')"
                                                        (click)="deleteLocation(record.location)"
                                                    >
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.companyName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Code') }}</span>
                                        {{ record.location.code }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.location.name }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Address1') }}</span>
                                        {{ record.location.address1 }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Phone') }}</span>
                                        {{ record.location.phone }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Email') }}</span>
                                        {{ record.location.email }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getLocations($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
